import { ChangeEvent, ClipboardEventHandler, FocusEventHandler } from "react";

import { Control, FieldValues } from "react-hook-form";

import {
  formatAlphabetic,
  formatAlphaNumeric,
  formatIp,
  formatLandPhoneNumber,
  formatMail,
  formatNumeric,
  formatOrderId,
  formatPhoneNumber,
  formatxid,
} from "utils/textfield.utils";

type INPUT_TYPES =
  | "alphabetic"
  | "numeric"
  | "alphaNumeric"
  | "phoneNumber"
  | "landPhoneNumber"
  | "mail"
  | "orderId"
  | "xid"
  | "ip"
  | "masked";

export interface TextFieldStyleProps {
  disabled?: boolean;
  error?: string;
  iconOpen?: boolean;
}

export type VARIANT_TYPES = "standart" | "smaller";

export interface TextFieldProps extends TextFieldStyleProps {
  name: string;
  label?: string;
  value?: string;
  variant?: VARIANT_TYPES;
  textFieldImageSrc?: string;
  defaultValue?: string;
  formatValue?: (value: string) => string | number;
  control?: Control<FieldValues>;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  onKeyDown?: React.KeyboardEventHandler<HTMLInputElement>;
  onBlur?: FocusEventHandler<HTMLInputElement>;
  maxLength?: number;
  iconOpen?: boolean;
  onPaste?: ClipboardEventHandler<HTMLInputElement>;
  tooltipInfo?: string;
  type?: INPUT_TYPES;
  onError?: (clientHeight?: number) => void;
  placeholder?: string;
}

export const input = (value = "", type?: INPUT_TYPES): string => {
  switch (type) {
    case "phoneNumber":
      return formatPhoneNumber(value);
    case "landPhoneNumber":
      return formatLandPhoneNumber(value);
    default:
      return value;
  }
};

export const output = (
  value: string,
  type?: INPUT_TYPES
): string | undefined => {
  switch (type) {
    case "phoneNumber":
      return formatNumeric(value);
    case "landPhoneNumber":
      return formatNumeric(value);
    case "numeric":
      return formatNumeric(value);
    case "alphabetic":
      return formatAlphabetic(value);
    case "alphaNumeric":
      return formatAlphaNumeric(value);
    case "mail":
      return formatMail(value);
    case "orderId":
      return formatOrderId(value);
    case "xid":
      return formatxid(value);
    case "ip":
      return formatIp(value);
    default:
      return value.length && value !== " " ? value : undefined;
  }
};

export const getPatternType = (type?: INPUT_TYPES): string => {
  switch (type) {
    case "phoneNumber":
      // eslint-disable-next-line no-useless-escape
      return `\d*`;
    case "numeric":
      // eslint-disable-next-line no-useless-escape
      return `\d*`;
    default:
      return "";
  }
};
